import {  usePutHttp } from "../../http.hook";
import type { IFavoriteSocial } from "./get-favorites-by-id.admin.http";

interface IResponse {
 favoriteSocial: IFavoriteSocial;
}

interface IBody{
    socials: Array<string>;
}

export function useAddSocialToFavoriteCollectionAdminHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/admin/favourite-socials/:id/add",
  });
}
